// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}


.flatpickr-months .flatpickr-month {background-color: #8A36FF !important }
.flatpickr-current-month .flatpickr-monthDropdown-months{background-color: #8A36FF !important}
span.flatpickr-weekday {background-color: #8A36FF !important;color:#ffffff!important}
.flatpickr-weekdays{background-color: #8A36FF !important;}
.flatpickr-day.selected{
  background-color: #8A36FF !important;
  border:#8A36FF
}

.select__value-container{flex-wrap:nowrap!important; overflow-x:auto!important;}
.select__value-container .select__multi-value {
  flex: 0 0 auto;
}

.active-dev-pagination a{
  background-color: #2E3191!important;
  color:#ffffff
}

.form_grp_bottom .basic-multi-select {
  margin-bottom: 0.75rem;
}.h-scroll .select__value-container {
  max-width: 240px;
}

.active-dev-pagination a:hover{
  color:#ffffff
}

#openChatBtn {
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  margin: 20px;
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 1001;
}

#chatPopup {
  display: block;
  position: fixed;
  bottom: 80px;
  right: 20px;
  width: 350px;
  background-color: white;
  box-shadow: 0 0 10px rgba(0,0,0,0.2);
  border-radius: 10px;
  overflow: hidden;
  z-index: 1000;
}

.chat-header {
  font-size: 20px;
  font-weight: bold;
  padding: 15px;
  background-color: #f5f5f5;
  position: relative;
}

.chat-header .close {
  position: absolute;
  right: 15px;
  top: 15px;
  cursor: pointer;
  font-size: 18px;
}

.chat-content {
  padding: 15px;
}

.chat-section {
  margin-bottom: 20px;
}

.chat-section-title {
  font-weight: bold;
  font-size: 14px;
  margin-bottom: 10px;
}

.chat-option {
  background-color: #f9f9f9;
  border: 1px solid #ddd;
  padding: 10px;
  border-radius: 8px;
  margin-bottom: 8px;
  cursor: pointer;
}

.chat-input {
  border-top: 1px solid #ccc;
  padding: 10px;
  display: flex;
}

.chat-input input {
  flex: 1 1;
  padding: 8px;
  border: none;
  outline: none;
}

.chat-input button {
  background-color: transparent;
  border: none;
  font-size: 18px;
  cursor: pointer;
}

.beta-badge {
  background-color: #005eff;
  color: white;
  padding: 2px 6px;
  font-size: 12px;
  border-radius: 5px;
  margin-left: 6px;
}


.react-grid-placeholder {
  background: transparent !important;
  opacity: 0 !important;
}

/* Remove background from grid items on hover/active */
.react-grid-item {
  background: transparent !important;
  transition: none !important;
}

.react-grid-item.react-grid-placeholder {
  background: transparent !important;
}

/* Remove resize handle styling if needed */
.react-resizable-handle {
  background: none !important;
  border: none !important;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,gCAAgC;AAChC;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA,YAAY;AACZ;EACE,0BAA0B;AAC5B;;;AAGA,oCAAoC,qCAAqC;AACzE,yDAAyD,oCAAoC;AAC7F,wBAAwB,oCAAoC,CAAC,uBAAuB;AACpF,oBAAoB,oCAAoC,CAAC;AACzD;EACE,oCAAoC;EACpC;AACF;;AAEA,yBAAyB,0BAA0B,EAAE,yBAAyB,CAAC;AAC/E;EACE,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC;AACF;;AAEA;EACE,sBAAsB;AACxB,CAAC;EACC,gBAAgB;AAClB;;AAEA;EACE;AACF;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;EACf,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,oCAAoC;EACpC,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,aAAa;EACb,aAAa;AACf;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;;AAGA;EACE,kCAAkC;EAClC,qBAAqB;AACvB;;AAEA,sDAAsD;AACtD;EACE,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;AACpC;;AAEA,2CAA2C;AAC3C;EACE,2BAA2B;EAC3B,uBAAuB;AACzB","sourcesContent":["/* Chrome, Safari, Edge, Opera */\r\ninput::-webkit-outer-spin-button,\r\ninput::-webkit-inner-spin-button {\r\n  -webkit-appearance: none;\r\n  margin: 0;\r\n}\r\n\r\n/* Firefox */\r\ninput[type=number] {\r\n  -moz-appearance: textfield;\r\n}\r\n\r\n\r\n.flatpickr-months .flatpickr-month {background-color: #8A36FF !important }\r\n.flatpickr-current-month .flatpickr-monthDropdown-months{background-color: #8A36FF !important}\r\nspan.flatpickr-weekday {background-color: #8A36FF !important;color:#ffffff!important}\r\n.flatpickr-weekdays{background-color: #8A36FF !important;}\r\n.flatpickr-day.selected{\r\n  background-color: #8A36FF !important;\r\n  border:#8A36FF\r\n}\r\n\r\n.select__value-container{flex-wrap:nowrap!important; overflow-x:auto!important;}\r\n.select__value-container .select__multi-value {\r\n  flex: 0 0 auto;\r\n}\r\n\r\n.active-dev-pagination a{\r\n  background-color: #2E3191!important;\r\n  color:#ffffff\r\n}\r\n\r\n.form_grp_bottom .basic-multi-select {\r\n  margin-bottom: 0.75rem;\r\n}.h-scroll .select__value-container {\r\n  max-width: 240px;\r\n}\r\n\r\n.active-dev-pagination a:hover{\r\n  color:#ffffff\r\n}\r\n\r\n#openChatBtn {\r\n  color: white;\r\n  border: none;\r\n  border-radius: 5px;\r\n  cursor: pointer;\r\n  margin: 20px;\r\n  position: fixed;\r\n  right: 20px;\r\n  bottom: 20px;\r\n  z-index: 1001;\r\n}\r\n\r\n#chatPopup {\r\n  display: block;\r\n  position: fixed;\r\n  bottom: 80px;\r\n  right: 20px;\r\n  width: 350px;\r\n  background-color: white;\r\n  box-shadow: 0 0 10px rgba(0,0,0,0.2);\r\n  border-radius: 10px;\r\n  overflow: hidden;\r\n  z-index: 1000;\r\n}\r\n\r\n.chat-header {\r\n  font-size: 20px;\r\n  font-weight: bold;\r\n  padding: 15px;\r\n  background-color: #f5f5f5;\r\n  position: relative;\r\n}\r\n\r\n.chat-header .close {\r\n  position: absolute;\r\n  right: 15px;\r\n  top: 15px;\r\n  cursor: pointer;\r\n  font-size: 18px;\r\n}\r\n\r\n.chat-content {\r\n  padding: 15px;\r\n}\r\n\r\n.chat-section {\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.chat-section-title {\r\n  font-weight: bold;\r\n  font-size: 14px;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.chat-option {\r\n  background-color: #f9f9f9;\r\n  border: 1px solid #ddd;\r\n  padding: 10px;\r\n  border-radius: 8px;\r\n  margin-bottom: 8px;\r\n  cursor: pointer;\r\n}\r\n\r\n.chat-input {\r\n  border-top: 1px solid #ccc;\r\n  padding: 10px;\r\n  display: flex;\r\n}\r\n\r\n.chat-input input {\r\n  flex: 1;\r\n  padding: 8px;\r\n  border: none;\r\n  outline: none;\r\n}\r\n\r\n.chat-input button {\r\n  background-color: transparent;\r\n  border: none;\r\n  font-size: 18px;\r\n  cursor: pointer;\r\n}\r\n\r\n.beta-badge {\r\n  background-color: #005eff;\r\n  color: white;\r\n  padding: 2px 6px;\r\n  font-size: 12px;\r\n  border-radius: 5px;\r\n  margin-left: 6px;\r\n}\r\n\r\n\r\n.react-grid-placeholder {\r\n  background: transparent !important;\r\n  opacity: 0 !important;\r\n}\r\n\r\n/* Remove background from grid items on hover/active */\r\n.react-grid-item {\r\n  background: transparent !important;\r\n  transition: none !important;\r\n}\r\n\r\n.react-grid-item.react-grid-placeholder {\r\n  background: transparent !important;\r\n}\r\n\r\n/* Remove resize handle styling if needed */\r\n.react-resizable-handle {\r\n  background: none !important;\r\n  border: none !important;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
